export const checkIsHideRegisterWarrantyBtn = ({ warrantyStatus, hasWarranty, enablePosIntegration = true }) => {
  return warrantyStatus || !hasWarranty || enablePosIntegration;
};
